// extracted by mini-css-extract-plugin
export var buttons = "_bv-0";
export var buttonsActive = "_bv-h";
export var cancelConfirm = "_bv-1";
export var closeButton = "_bv-2";
export var column = "_bv-3";
export var container = "_bv-4";
export var detailHeader = "_bv-6";
export var detailTitle = "_bv-7";
export var detailsContent = "_bv-5";
export var header = "_bv-8";
export var headerWithClose = "_bv-9";
export var icon = "_bv-a";
export var infoIcon = "_bv-c";
export var informationContainer = "_bv-b";
export var sideDrawer = "_bv-d";
export var sideDrawerOpen = "_bv-e";
export var stickyFooter = "_bv-f";
export var typeOption = "_bv-g";